import React from "react";
import "./HeroWordMarquee.css";

const HERO_WORDS = ["REMEMBER", "CARE", "MOOD", "LEGACY"];

const HeroWordGroup: React.FC = () => (
  <div className="hero-word-marquee__group">
    {HERO_WORDS.map((word) => (
      <span className="hero-word-marquee__word" key={word}>
        {word}
      </span>
    ))}
  </div>
);

const HeroWordMarquee: React.FC = () => (
  <div className="hero-word-marquee" aria-hidden="true">
    <div className="hero-word-marquee__track">
      <HeroWordGroup />
      <HeroWordGroup />
    </div>
  </div>
);

export default HeroWordMarquee;
